import { FiMonitor, FiShield, FiSmartphone } from "react-icons/fi";
import { useQuery } from "@tanstack/react-query";
import { hasPermission } from "../entities/access";
import { shellBootstrapQuery } from "./bootstrap";
import type { ShellServices } from "./services";

import { NavigationCards } from "./NavigationCards";
import type { WorkspaceNavigationItem } from "./workspaceNavigation";

/** Разделы аккаунта: у каждого пользователя они одни и те же, права для них не нужны. */
const accountSections: readonly WorkspaceNavigationItem[] = [
  {
    key: "account-security",
    path: "/account/security",
    label: "Безопасность",
    description: "Пароль, двухфакторная защита и коды восстановления",
    icon: FiShield,
  },
  {
    key: "account-sessions",
    path: "/account/sessions",
    label: "Сессии",
    description: "Устройства, с которых выполнен вход, и их завершение",
    icon: FiMonitor,
  },
  {
    key: "account-about",
    path: "/about",
    label: "О приложении",
    description: "Версия, установка на устройство, обновления и уведомления",
    icon: FiSmartphone,
  },
];

export function AccountPage({ services }: { services: ShellServices }) {
  const bootstrap = useQuery(shellBootstrapQuery(services)).data;
  const allowed = [
    "document-workflow.substitutions.manage",
    "document-workflow.substitutions.manage.any",
  ].some((permission) =>
    hasPermission({ permissions: bootstrap?.permissions ?? [] }, permission),
  );
  return (
    <section className="workspace-page" aria-labelledby="account-title">
      <div className="page-heading">
        <p className="eyebrow">Личный кабинет</p>
        <h1 id="account-title">Аккаунт и приложение</h1>
        <p>
          Защита входа, активные сессии и сведения о самом приложении: версия,
          установка и обновления.
        </p>
      </div>
      <NavigationCards
        items={
          allowed
            ? [
                ...accountSections,
                {
                  key: "my-substitution",
                  path: "/account/substitution",
                  label: "Моё замещение",
                  description: "Кто заменит меня на время отсутствия",
                  icon: FiMonitor,
                },
              ]
            : accountSections
        }
      />
    </section>
  );
}
